import { Exclude, Expose, Transform, Type } from 'class-transformer';
import { PlatformScheduleAssetDTO } from './platform-schedule-asset.dto';
import { ValidationOptions, ValidationArguments, registerDecorator, ValidateIf, IsNotEmpty } from 'class-validator';
import moment, { Moment } from 'moment';
import { PlatformScheduleMetadataDTO } from './platform-schedule-metadata.dto';
import { PlatformDTO } from './platform.dto';
import { environment } from '../environments/environment';
import { FirstCommentInfoDTO } from './first-comment-info.dto';

export function IsValidDate(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      constraints: [],
      validator: {
        validate(value: any, args: ValidationArguments) {
          if (value) {
            try {
              return value.isValid();
            } catch (e) {}
          }
          return false;
        }
      }
    });
  };
}

export function IsFutureDate(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      constraints: [],
      validator: {
        validate(value: any, args: ValidationArguments) {
          if (value) {
            try {
              const lowerLimit = moment().add(environment.autoPostMinDelayMinutes ?? 5, 'minutes');
              return value.isAfter(lowerLimit);
            } catch (e) {
              // console.error(e);
            } //any exception thrown will result in return false
          }
          return false;
        }
      }
    });
  };
}

@Exclude()
export class PlatformScheduleDTO {
  @Expose()
  id: number;

  @Expose()
  platformScheduleGroupId: number;

  @Expose()
  platformAccountId: number;

  @Expose()
  platformId: number;

  @Expose()
  sortOrder: number;

  @Expose()
  platformSchedulePostType: string;

  @Expose()
  source: string;

  @Expose()
  caption: string;

  @Expose()
  error: string;

  @Expose()
  @IsValidDate({
    message: 'Please enter the date and time in a correct format'
  })
  @IsFutureDate({
    message: `Please schedule at least ${environment.autoPostMinDelayMinutes ?? 5} minute${environment.autoPostMinDelayMinutes !== 1 ? 's' : ''} in the future`
  })
  @Transform((value) => (moment.isMoment(value) ? value.toISOString() : value), {
    toPlainOnly: true
  })
  @Type(() => moment)
  scheduleDate: Moment;

  @Expose()
  isEnabled: boolean;

  @Expose()
  status: string;

  @Expose()
  __typename: string;

  @Expose()
  posted: boolean;

  @Expose()
  collaborators: string[];

  @Expose()
  platformScheduleAssets: PlatformScheduleAssetDTO[];

  @Expose()
  platformScheduleComment: FirstCommentInfoDTO;

  @Expose()
  platformScheduleMetadata: PlatformScheduleMetadataDTO[];

  @Expose()
  platform: PlatformDTO;

  file: File;

  selected: boolean;

  generatedCaptionAnalytics: any;
}
